export const toggleAccordion = (target,root) => {
    const associatedSection = root.querySelector(`[data-js='${target.getAttribute("data-toggle")}']`);
    target.classList.toggle('expanded');
    associatedSection.classList.toggle('employee_register__accordion--open');
    target.setAttribute('aria-expanded', target.classList.contains('expanded'));
    associatedSection.setAttribute('aria-hidden', !target.classList.contains('expanded'));
};